import { Button, Spin, message } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import {
  ArrowRightOutlined,
  ArrowLeftOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { bookPhysicalClass, setPhysicalClassData } from '@/actions/physical-class';
import moment from 'moment';

type Props = {
  summaryData: any;
  courseData: any;
  dateData: any;
  backBtn: () => void;
  start_time: string;
  end_time: string;
  dateRange: string;
};

const Summary: FC<Props> = ({
  summaryData,
  courseData,
  dateData,
  backBtn,
  start_time,
  end_time,
  dateRange,
}) => {
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const [completed, setCompleted] = useState(false);
  const status = useSelector(
    (state: any) => state.physicalClass.status?.bookClassStatus
  );
  const error = useSelector(
    (state: any) => state.physicalClass.error?.bookClassError
  );

  useEffect(() => {
    dispatch(
      setPhysicalClassData({ name: 'status', key: 'bookClassStatus', value: '' })
    );
    return () => {
      dispatch(
        setPhysicalClassData({ name: 'status', key: 'bookClassStatus', value: '' })
      );
      setCompleted(false);
    };
  }, []);

  useEffect(() => {
    if (status == 'failed') {
      messageApi.error(error || 'Failed to book class.');
      setCompleted(true);
    } else if (status == 'success') {
      messageApi.success('Successfully booked your class.');
      setCompleted(true);
    }
  }, [status]);

  const finishBook = () => {
    const finishData = {
      ...summaryData,
      start_time: start_time.trim(),
      end_time: end_time.trim(),
      date: dateData,
      physical_class: courseData?.id,
    };
    dispatch(bookPhysicalClass(finishData));
  };
  return status == 'request' ? (
    <div
      className="d-flex w-100 justify-content-center align-items-center"
      style={{ height: '200px' }}
    >
      <Spin />
    </div>
  ) : (
    <div className="pt-2" style={{ textAlign: 'center' }}>
      {contextHolder}
      <p className="m-0 p-0 font-weight-bold" style={{ fontSize: '16px' }}>
        Summary
      </p>
      {!completed ? (
        <div className="d-flex flex-column w-100">
          <div>
            <p className="m-0 p-0">Your physical class booking summary</p>
          </div>
          <div className="py-4 mb-3">
            <p className="m-0 p-0 font-weight-bold " style={{ fontSize: '16px' }}>
              Customer
            </p>
            <p className="m-0 p-0">
              {summaryData?.first_name} {summaryData?.last_name}
            </p>
            <p className="m-0 p-0">{summaryData?.email}</p>
            <p className="m-0 p-0">{summaryData?.phone_number}</p>
          </div>
          <div className=" d-flex pb-4 gap-2 align-items-center justify-content-center">
            <div>
              <p className="m-0 p-0 font-weight-bold" style={{ fontSize: '16px' }}>
                Service
              </p>
              <p className="m-0 p-0">{courseData?.name}</p>
            </div>
            <div>
              <hr style={{ transform: 'rotate(90deg)', width: '50px' }} />
            </div>
            <div>
              <p className="m-0 p-0 font-weight-bold" style={{ fontSize: '16px' }}>
                Date
              </p>
              <p className="m-0 p-0">{`${dateRange}`}</p>
            </div>
          </div>
          <div>
            <p className="m-0 p-0 font-weight-bold" style={{ fontSize: '16px' }}>
              Duration
            </p>
            <p className="mb-3 p-0">{courseData?.course_duration} days</p>
          </div>
          <div>
            <p className="m-0 p-0 font-weight-bold" style={{ fontSize: '16px' }}>
              Time
            </p>
            <p className="m-0 p-0">
              {moment(start_time, 'HH:mm').format('hh:mm A')} -{' '}
              {moment(end_time, 'HH:mm').format('hh:mm A')}
            </p>
          </div>
          <hr />
          <div className=" d-flex flex-wrap justify-content-between mb-4">
            <p className="m-0 p-0 font-weight-bold" style={{ fontSize: '16px' }}>
              Total Amount Payable
            </p>
            <p className="m-0 p-0 font-weight-bold" style={{ color: '#283360' }}>
              NRs. {courseData?.price}
            </p>
          </div>
          <div className="my-2 d-flex gap-2 justify-content-end ">
            <Button className="float-right" onClick={backBtn}>
              <div className="d-flex gap-2 align-items-center">
                <ArrowLeftOutlined rev="" /> Back
              </div>
            </Button>

            <Button type="primary" className="float-right" onClick={finishBook}>
              <div className="d-flex gap-2 align-items-center">
                Submit <ArrowRightOutlined rev="" />
              </div>
            </Button>
          </div>
        </div>
      ) : status == 'success' ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: '100px' }}
        >
          <div className="d-flex gap-2">
            <div className="d-flex align-items-center">
              <CheckCircleOutlined
                rev=""
                style={{ color: 'green', fontSize: '23px' }}
              />
            </div>
            <p style={{ fontSize: '23px', fontWeight: 'bold' }}>
              Completed booking !
            </p>
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: '100px' }}
        >
          <div className="d-flex gap-2">
            <div className="d-flex align-items-center">
              <CloseCircleOutlined
                rev=""
                style={{ color: 'red', fontSize: '23px' }}
              />
            </div>
            <p style={{ fontSize: '23px', fontWeight: 'bold', color: 'red' }}>
              Failed booking !
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Summary;
